<div class="prizm-navigation-menu">
  <header class="prizm-navigation-menu__header header">
    <div class="header__top" (prizmHoveredChange)="headerIsHovered = $event">
      <div class="header__title" #elem [prizmHint]="title" [prizmHintCanShow]="prizmIsTextOverflow(elem)">
        {{ title }}
      </div>
      <div class="header__instruments">
        <ng-container
          [ngTemplateOutlet]="headerExtraTemplate"
          [ngTemplateOutletContext]="{ headerIsHovered: headerIsHovered }"
        ></ng-container>
        <button
          *ngIf="headerConfiguration.showSettings"
          [size]="'m'"
          [icon]="'gear-8-edge'"
          [appearance]="'secondary'"
          [appearanceType]="'ghost'"
          (click)="handleSettingsClicked()"
          prizmIconButton
        ></button>
        <button
          *ngIf="headerConfiguration.showHome"
          [size]="'m'"
          [icon]="'house'"
          [appearance]="'secondary'"
          [appearanceType]="'ghost'"
          (click)="handleHomeClicked()"
          prizmIconButton
        ></button>
      </div>
    </div>
    <prizm-navigation-menu-toolbar
      class="header__toolbar"
      [searchConfig]="$any(menuSearchConfig$ | async)"
      [toolbarConfig]="$any(menuToolbarConfig$ | async)"
      [toolbarExtraTemplate]="toolbarExtraTemplate"
    ></prizm-navigation-menu-toolbar>
  </header>

  <main class="prizm-navigation-menu__content groups-content" [ngClass]="settingsConfiguration.selectedSize">
    <ng-container *ngIf="menuGroups.length; else noGroups">
      <prizm-scrollbar class="scrollable">
        <section class="groups-content__top">
          <ng-content></ng-content>
          <ng-content select="[top]"></ng-content>
        </section>
      </prizm-scrollbar>
      <section class="groups-content__bottom">
        <ng-content select="[bottom]"></ng-content>
      </section>
    </ng-container>

    <ng-template #noGroups>
      <prizm-scrollbar class="scrollable">
        <div class="no-groups-content" [class.no-groups-content__empty]="!items?.length">
          <prizm-navigation-menu-group
            [groupId]="'prizm-navigation-menu-default-group'"
            [hideGroupAppearance]="true"
            [items]="items"
            [toolbarExtraTemplate]="toolbarExtraTemplate"
            [itemExtraTemplate]="itemExtraTemplate"
            [searchConfig]="$any(menuSearchConfig$ | async)"
            [toolbarConfig]="$any(menuToolbarConfig$ | async)"
            [emptySearchResultMessageConfig]="$any(emptySearchResultMessageConfig$ | async)"
            [emptyDataMessageConfig]="$any(emptyDataMessageConfig$ | async)"
          ></prizm-navigation-menu-group>
        </div>
      </prizm-scrollbar>
    </ng-template>
  </main>
</div>
